import { InputNumber, InputNumberProps } from "antd";
import styles from "./index.module.css";

export const CustomInputNumber = (props: InputNumberProps) => {
  return (
    <InputNumber
      {...props}
      controls={props?.controls ?? false}
      onKeyDown={(event) => {
        const re = /^[0-9/b]+$/;
        if (
          (!re.test(event.key) && event.key !== "Backspace" && event.key !== ".") ||
          event.key === "/" ||
          (event.currentTarget.value.includes(".") && event.key === ".")
        ) {
          event.preventDefault();
          return;
        }
        if (props?.onKeyDown) props.onKeyDown(event);
      }}
      formatter={(value) => {
        return value
          ? Number(value)
              .toLocaleString("en-EN", {
                maximumFractionDigits: 2,
              })
              .replaceAll(",", " ")
          : "";
      }}
      className={props.className ? props.className + " " + styles.customInput : styles.customInput}
    />
  );
};
